import { render, staticRenderFns } from "./FormPostWelcome.vue?vue&type=template&id=e87af1c4&"
import script from "./FormPostWelcome.vue?vue&type=script&lang=js&"
export * from "./FormPostWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports